/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * properties_service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Type of entity that can be referenced by entity properties.
 */
export type EntityType = (typeof EntityType)[keyof typeof EntityType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EntityType = {
  CHANNEL: 'CHANNEL',
  CHAT: 'CHAT',
  COMPANY: 'COMPANY',
  DOCUMENT: 'DOCUMENT',
  PROJECT: 'PROJECT',
  TASK: 'TASK',
  THREAD: 'THREAD',
  USER: 'USER',
} as const;
